export default __webpack_public_path__ + "static/media/K2D-SemiBoldItalic.618cab12.ttf";